import { FormControlLabel, styled, Switch } from "@mui/material";
import OnOff from '../../assets/images/onOff.svg';

const OnOffSwitchForDeleted = ({ checkDeleted, setCheckDeleted }) => {

    const MaterialUISwitch = styled(Switch)(({ theme }) => ({
        width: 62,
        height: 34,
        padding: 7,
        '& .MuiSwitch-switchBase': {
            margin: 1,
            padding: 0,
            transform: 'translateX(6px)',
            '&.Mui-checked': {
                color: '#fff',
                transform: 'translateX(22px)',
                '& .MuiSwitch-thumb:before': {
                    backgroundImage: `url(${OnOff})`
                },
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: '#aab4be',
                    ...theme.applyStyles('light', {
                        backgroundColor: '#adebad',
                    }),
                },
            },
        },
        '& .MuiSwitch-thumb': {
            backgroundColor: '#001e3c',
            width: 32,
            height: 32,
            '&::before': {
                content: "''",
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: '20px 20px',
                backgroundImage: `url(${OnOff})`
            },
            ...theme.applyStyles('light', {
                backgroundColor: checkDeleted ? '#ff0000' : '#33cc33',
            }),
        },
        '& .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: '#aab4be',
            borderRadius: 20 / 2,
            ...theme.applyStyles('light', {
                backgroundColor: '#ff9999',
            }),
        },
    }));

    return (
        <FormControlLabel

            control={<MaterialUISwitch sx={{ backgroundColor: 'red', color: 'red' }}
                checked={!checkDeleted}
                onClick={() => {
                    setCheckDeleted((prevChecked) => {
                        const newChecked = !prevChecked;
                        return newChecked;
                    });
                }} />}
        />);
}

export default OnOffSwitchForDeleted;